import styled from 'styled-components';
import { Form } from '@/components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${COLORS.DARK_ONYX};
  height: 100%;
`;

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledInputLabel = styled.label`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
`;

export const StyledWarning = styled.div`
  ${pickThemeFontStyles('15', '18', 'SEMI_BOLD')};
  color: ${COLORS.RED};
`;
